import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, HostBinding, HostListener, ContentChild, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { v4 } from 'uuid';

class InputInputComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.componentClass = true;
        this.newInputEvent = new EventEmitter();
    }
    onInput(event) {
        this.newInputEvent.emit(event.target.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputInputComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.3", type: InputInputComponent, isStandalone: true, selector: "[c11nInput]", host: { listeners: { "input": "onInput($event)" }, properties: { "class.c11n-input__input": "this.componentClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host(.c11n-input__input){appearance:none;display:block;font-family:FF Mark,Arial,sans-serif;font-weight:400;font-style:normal;font-size:1.0625rem;line-height:1.4117647059;font-variant-numeric:tabular-nums;width:100%;height:3rem;overflow:visible;margin:0;padding:0 1rem .25rem;color:#040505;background:#fff;border:.0625rem solid #040505;border-radius:0}:host(.c11n-input__input) *{box-sizing:border-box}:host(.c11n-input__input)::placeholder{color:#717777}:host(.c11n-input__input):focus{outline:none}:host-context(.c11n-input.c11n-input--large){height:4rem;font-family:FF Mark,Arial,sans-serif;font-weight:400;font-style:normal;font-size:1.4375rem;line-height:1.3913043478;font-variant-numeric:tabular-nums;padding:0 1rem .25rem}:host-context(.c11n-input.c11n-input--error){border:.0625rem solid #ba3d21}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputInputComponent, decorators: [{
            type: Component,
            args: [{ selector: '[c11nInput]', standalone: true, imports: [CommonModule], template: '<ng-content></ng-content>', changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host(.c11n-input__input){appearance:none;display:block;font-family:FF Mark,Arial,sans-serif;font-weight:400;font-style:normal;font-size:1.0625rem;line-height:1.4117647059;font-variant-numeric:tabular-nums;width:100%;height:3rem;overflow:visible;margin:0;padding:0 1rem .25rem;color:#040505;background:#fff;border:.0625rem solid #040505;border-radius:0}:host(.c11n-input__input) *{box-sizing:border-box}:host(.c11n-input__input)::placeholder{color:#717777}:host(.c11n-input__input):focus{outline:none}:host-context(.c11n-input.c11n-input--large){height:4rem;font-family:FF Mark,Arial,sans-serif;font-weight:400;font-style:normal;font-size:1.4375rem;line-height:1.3913043478;font-variant-numeric:tabular-nums;padding:0 1rem .25rem}:host-context(.c11n-input.c11n-input--error){border:.0625rem solid #ba3d21}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { componentClass: [{
                type: HostBinding,
                args: ['class.c11n-input__input']
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

class InputComponent {
    constructor() {
        this._destroy = new Subject();
        /** The input size. Impacts `labelText`, `hintText`, `errorText`, and the content. */
        this.size = 'medium';
        /** Indicates an error state. When `true`, the `hintText` is replaced by `errorText`. */
        this.hasError = false;
        this.isMedium = false;
        this.isLarge = false;
        this.rangeError = false;
        this.inputId = '';
    }
    ngOnInit() {
        this.updateSizeRelated();
    }
    ngAfterContentInit() {
        try {
            this.inputElement = this.textInput.elRef.nativeElement;
            const inputElementId = this.inputElement.id;
            if (inputElementId) {
                this.inputId = inputElementId;
            }
            else {
                this.inputId = v4();
                this.inputElement.id = this.inputId;
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    ngOnChanges(changes) {
        Object.keys(changes)
            .filter((chg) => ['size'].includes(chg))
            .forEach((key) => {
            if (!changes[key].isFirstChange()) {
                this.updateSizeRelated();
            }
        });
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
    updateSizeRelated() {
        this.isMedium = this.size === 'medium';
        this.isLarge = this.size === 'large';
    }
    ;
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.3", type: InputComponent, isStandalone: true, selector: "c11n-input", inputs: { size: "size", hasError: "hasError" }, host: { properties: { "class.c11n-input--error": "this.hasError", "class.c11n-input--medium": "this.isMedium", "class.c11n-input--large": "this.isLarge", "class.c11n-input--rangeerror": "this.rangeError" }, classAttribute: "c11n-input" }, queries: [{ propertyName: "textInput", first: true, predicate: InputInputComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-content select=\"[c11nInput]\"></ng-content>\n<div class=\"c11n-input__focus-element\"></div>", styles: [":host(.c11n-input){position:relative;display:block;padding:0;margin:0;width:100%;height:auto;box-sizing:border-box;background:transparent;overflow:visible}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:before,:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:after{content:\"\";display:block;position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;pointer-events:none}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:before{outline:solid .125rem #ffffff;outline-offset:.25rem}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:after{outline:solid .125rem #0f62c5;outline-offset:.125rem}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'c11n-input', standalone: true, imports: [CommonModule, InputInputComponent], changeDetection: ChangeDetectionStrategy.OnPush, host: { class: 'c11n-input' }, template: "<ng-content select=\"[c11nInput]\"></ng-content>\n<div class=\"c11n-input__focus-element\"></div>", styles: [":host(.c11n-input){position:relative;display:block;padding:0;margin:0;width:100%;height:auto;box-sizing:border-box;background:transparent;overflow:visible}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:before,:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:after{content:\"\";display:block;position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;pointer-events:none}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:before{outline:solid .125rem #ffffff;outline-offset:.25rem}:host(.c11n-input) ::ng-deep .c11n-input__input:focus-visible~.c11n-input__focus-element:after{outline:solid .125rem #0f62c5;outline-offset:.125rem}\n"] }]
        }], propDecorators: { textInput: [{
                type: ContentChild,
                args: [InputInputComponent]
            }], size: [{
                type: Input
            }], hasError: [{
                type: HostBinding,
                args: ['class.c11n-input--error']
            }, {
                type: Input
            }], isMedium: [{
                type: HostBinding,
                args: ['class.c11n-input--medium']
            }], isLarge: [{
                type: HostBinding,
                args: ['class.c11n-input--large']
            }], rangeError: [{
                type: HostBinding,
                args: ['class.c11n-input--rangeerror']
            }] } });

class InputModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: InputModule, imports: [InputComponent, InputInputComponent], exports: [InputComponent, InputInputComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputModule, imports: [InputComponent, InputInputComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: InputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [InputComponent, InputInputComponent],
                    exports: [InputComponent, InputInputComponent],
                }]
        }] });

const getDateString = (date, sequence, delimiter) => {
    const dateParts = getDateParts(date);
    const partsList = sequence === 'DMY' ? [dateParts.day, dateParts.month] : [dateParts.month, dateParts.day];
    sequence === 'YMD' ? partsList.unshift(dateParts.year) : partsList.push(dateParts.year);
    const dateString = partsList.join(delimiter);
    return dateString;
};
const getDateObject = (str, sequence, delimiter) => {
    const dateArray = str.split(delimiter);
    const monthIndex = sequence === 'MDY' ? 0 : 1;
    const dayIndex = sequence === 'DMY' ? 0 : sequence === 'YDM' ? 2 : 1;
    const yearIndex = sequence === 'YMD' ? 0 : 2;
    const dateObject = new Date(+dateArray[yearIndex], +dateArray[monthIndex] - 1, +dateArray[dayIndex]);
    return dateObject;
};
const getDateParts = (date) => {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    const year = date.getFullYear();
    if (day < 10)
        day = "0" + day;
    if (month < 10)
        month = "0" + month;
    return { month, day, year };
};
const InputMask = {
    CURRENCY: {
        mask: '$VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: Number,
                scale: 2,
                signed: false,
                thousandsSeparator: ',',
                padFractionalZeros: true,
                radix: '.',
            }
        }
    },
    SSN: {
        mask: '000-00-0000',
        lazy: false
    },
    SECURED_SSN: {
        mask: 'VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: '000-00-0000',
                blocks: {
                    0: {
                        mask: '0',
                        displayChar: '\u2022',
                    }
                }
            }
        }
    },
    EIN: {
        mask: '00-0000000',
        lazy: false
    },
    SECURED_EIN: {
        mask: 'VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: '00-0000000',
                blocks: {
                    0: {
                        mask: '0',
                        displayChar: '\u2022',
                    }
                }
            }
        }
    },
    ZIP: {
        mask: '00000',
        lazy: false,
    },
    EMAIL: {
        mask: 'VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: /^\S*@?\S*$/
            }
        }
    },
    PHONE: {
        mask: '000-000-0000',
        lazy: false
    },
    DATE_MDY_DASH: {
        mask: Date,
        pattern: 'm{-}`d{-}`Y',
        format: function (date) {
            return getDateString(date, 'MDY', '-');
        },
        parse: function (str) {
            return getDateObject(str, 'MDY', '-');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    DATE_MDY_SLASH: {
        mask: Date,
        pattern: 'm{/}`d{/}`Y',
        format: function (date) {
            return getDateString(date, 'MDY', '/');
        },
        parse: function (str) {
            return getDateObject(str, 'MDY', '/');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    DATE_MDY_DOT: {
        mask: Date,
        pattern: 'm{.}`d{.}`Y',
        format: function (date) {
            return getDateString(date, 'MDY', '.');
        },
        parse: function (str) {
            return getDateObject(str, 'MDY', '.');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    DATE_DMY_DASH: {
        mask: Date,
        pattern: 'd{-}`m{-}`Y',
        format: function (date) {
            return getDateString(date, 'DMY', '-');
        },
        parse: function (str) {
            return getDateObject(str, 'DMY', '-');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    DATE_DMY_SLASH: {
        mask: Date,
        pattern: 'd{/}`m{/}`Y',
        format: function (date) {
            return getDateString(date, 'DMY', '/');
        },
        parse: function (str) {
            return getDateObject(str, 'DMY', '/');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    DATE_DMY_DOT: {
        mask: Date,
        pattern: 'd{.}`m{.}`Y',
        format: function (date) {
            return getDateString(date, 'DMY', '.');
        },
        parse: function (str) {
            return getDateObject(str, 'DMY', '.');
        },
        min: new Date(1000, 0, 1),
        lazy: false,
    },
    PERCENT: {
        mask: 'VALUE%',
        lazy: false,
        blocks: {
            VALUE: {
                mask: Number,
                scale: 2,
                signed: false,
                thousandsSeparator: ',',
                padFractionalZeros: false,
                radix: '.',
            }
        }
    },
    NUMBER: {
        mask: 'VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: Number,
                scale: 20,
                signed: true,
                thousandsSeparator: ',',
                padFractionalZeros: false,
                radix: '.',
            }
        }
    },
    INTEGER: {
        mask: 'VALUE',
        lazy: false,
        blocks: {
            VALUE: {
                mask: Number,
                scale: 0,
                signed: true,
                thousandsSeparator: ',',
                padFractionalZeros: false,
                radix: '.',
            }
        }
    }
};

/**
 * Generated bundle index. Do not edit.
 */

export { InputComponent, InputInputComponent, InputMask, InputModule, getDateObject, getDateParts, getDateString };
